import app from 'flarum/common/app';
import Button from 'flarum/common/components/Button';
import ImpersonateModal from './ImpersonateModal';
export default class LoginAsUserButton extends Button {
  view() {
    return m(Button, {
      icon: "fas fa-id-card",
      onclick: this.loginAsUser.bind(this)
    }, app.translator.trans('fof-impersonate.lib.user_controls.impersonate_button'));
  }
  loginAsUser() {
    const {
      user,
      redirectTo
    } = this.attrs;
    app.modal.show(ImpersonateModal, {
      callback: () => {
        redirectTo ? window.location.href = redirectTo : window.location.reload();
      },
      user
    });
  }
}
flarum.reg.add('fof-impersonate', 'common/components/LoginAsUserButton', LoginAsUserButton);